/**
 * SE web → admin-api (Cloudflare Worker) base URL.
 *
 *   - In dev, an empty base + the Vite /api proxy keeps things same-origin.
 *   - In prod, default to the deployed Worker URL; override with
 *     VITE_SE_API_BASE in the build env to point at a custom domain.
 */
export const API_BASE: string =
  import.meta.env.VITE_SE_API_BASE ??
  (import.meta.env.PROD ? "https://se-admin-api.kishek12.workers.dev" : "");
